import { useResetAllFilterScopes } from '@statsbomb/kitbag-global-football';
import { useRef } from 'react';

export const useResetFiltersOnAreaEntry = () => {
  const resetAllFilterScopes = useResetAllFilterScopes();
  const hasReset = useRef(false);

  if (!hasReset.current) {
    hasReset.current = true;
    resetAllFilterScopes();
  }
};
